import { BackgroundVideo } from '../components/BackgroundVideo';

export function NotFoundPage() {
  return (
    <main id="main-content" className="main-wrapper">
      <section className="section_404">
        <div className="container-full-3">
          <div className="_404_content">
            <div className="_404_content-wrapper">
              <h1 className="heading-medium">
                <span className="text-color-primary500-2">woops, its 404!</span> seems like there is
                no page found
              </h1>
              <div>This page doesn’t seem to exist. Please verify the URL and try again.</div>
              <div className="button-row-2">
                <a
                  href="/"
                  data-motion-id="45f15ee9-b21b-bdde-08d3-340feebf5a1d"
                  className="button w-inline-block"
                >
                  <div className="button_text-wrapper">
                    <div>teleport to home page</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <BackgroundVideo
          name="19807699-uhd_3840_2024_25fps"
          className="hero_video"
          tone="green"
          eager
        />
      </section>
    </main>
  );
}
